// frontend/src/services/apiClient.js

import axios from 'axios';
import { getToken, logout } from '../utils/authHelpers';
import { getAppApiBase } from '../utils/getApiBase';


// 🔧 Create a configured axios instance
const axiosInstance = axios.create({
    baseURL: getAppApiBase(),
  withCredentials: true, // ✅ Needed if backend sets cookies or expects credentials
    headers: {
    'Content-Type': 'application/json', // ✅ Add this line
    'Accept': 'application/json',       // ✅ Optional but recommended
  }
});

// console.log("🌍 Base URL in use:", axiosInstance.defaults.baseURL);

// 🔐 Add Authorization token (JWT) to every request if available
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken(); // 🔍 Read token from localStorage

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;

      // 🧪 Only log tokens in development (not in production)
      if (process.env.NODE_ENV === 'development') {
        console.debug('🔐 Using Authorization header:', `Bearer ${token}`);
      }
    }

    return config;
  },
  (error) => {
    // ⛔ Forward any config errors
    return Promise.reject(error);
  }
);

// ⚠️ Handle global errors like expired/invalid token (401)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Axios response error:', error);

    // 🚪 Auto-logout user if unauthorized
    if (error.response && error.response.status === 401) {
      logout(); // 💥 Remove token from storage

      // 🔁 Redirect to login page unless already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
